// src/services/auth.js

import axios from 'axios';
import axiosInstance from '../services/axiosInstance';
import { queryClient } from './queryClient';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
console.log("Env is",process.env.REACT_APP_API_URL);

export const login = async (credentials) => {
    const response = await axios.post(`${API_BASE_URL}/token/`, credentials);
    const { access, refresh, password_change_required, id } = response.data;
    // Save tokens to localStorage or cookies
        localStorage.setItem('accessToken', access);
        localStorage.setItem('refreshToken', refresh);
    
    return { password_change_required, id };
};

export const changePassword = async ({ userid, password, password_change_required }) => {

    return await axiosInstance.put(`${API_BASE_URL}/pwreset/${userid}/`, {
        password,
        employee: {
            password_change_required,
        },
        
    });
};

export const requestPasswordReset = async (email) => {
    return await axios.post(`${API_BASE_URL}/password-reset/`, { email });
};

export const confirmPasswordReset = async ({ uid, token, new_password }) => {
    return await axios.post(`${API_BASE_URL}/password-reset-confirm/`, {
        uid,
        token,
        new_password
    });
};

export const logout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    // Logout→login is an SPA navigation, not a page reload, so the in-memory
    // QueryClient survives untouched unless cleared explicitly — otherwise
    // the next login would keep serving the previous session's stale product
    // list. queryClient.clear() also wipes the persisted localStorage copy
    // (see src/services/queryClient.js) since the persister syncs on cache changes.
    queryClient.clear();
};

export const getAccessToken = () => localStorage.getItem('accessToken');

export const isAuthenticated = () => !!getAccessToken();

